import { useEffect } from 'react';

import { useFormDataQuery } from '@/api/getters';
import { FormComponent } from '@/features/v2/lib/wizard';
import { PRODUCT_DATA } from '@/features/v2/product-data';

import { EcommerceStepper } from './components/EcommerceStepper';

const Ecommerce = () => {
  const { data } = useFormDataQuery();

  useEffect(() => {
    if (data?.payment_url) {
      window.location.href = data.payment_url;
    }
  }, [data?.payment_url]);

  if (!data) return null;

  const StageComponent =
    PRODUCT_DATA[data.product.id].stages[data.stage]?.component;
  const progress = PRODUCT_DATA[data.product.id].stages[data.stage]?.progress;

  return (
    <div className="w-full items-start lg:flex lg:gap-x-5">
      <div className="flex flex-col gap-[16px] lg:w-[670px] lg:gap-y-5">
        {progress && (
          <div className="fixed inset-x-1/2 top-[75px] z-40 w-full -translate-x-1/2 lg:hidden">
            <div className="relative w-full">
              <span className="translate-z-0 absolute left-0 top-[-12px] flex h-[41px] w-screen bg-oxford-blue-400" />
              <div className="mx-auto px-2.5 sm:max-w-screen-sm sm:px-4 md:max-w-tablet md:px-6">
                <EcommerceStepper progressType={progress} />
              </div>
            </div>
          </div>
        )}

        {StageComponent ? StageComponent : <FormComponent />}
      </div>

      {progress && (
        <EcommerceStepper
          progressType={progress}
          className="hidden lg:sticky lg:top-4 lg:flex lg:self-start"
        />
      )}
    </div>
  );
};

export default Ecommerce;
